// HELPROLES1 (docs/build-briefs/HELPROLES1-help-by-role-then-rhythm.md; design/style-guide.md section 11): the role picker and
// the rhythm grouping of the Help panel's All guides view. Pure, no DOM. The role names are the product's own role labels
// (src/domain/tenantRoles.ts). A role pick only filters the list of guides: it reads and grants no permission.

export interface HelpRole {
  readonly id: string;
  readonly label: string;
}

/** The location console's roles, in the order the product lists them. */
export const LOCATION_HELP_ROLES: readonly HelpRole[] = [
  { id: "lounger", label: "Lounger" },
  { id: "assistant_manager", label: "Assistant Lounge Manager" },
  { id: "manager", label: "Manager" },
  { id: "inventory_manager", label: "Inventory Manager" },
  { id: "admin", label: "Admin" },
  { id: "report_creator", label: "Report Creator" },
];

/** The rhythms, in the order they are shown. A guide's `group` is one of these. */
export const HELP_RHYTHMS: readonly string[] = ["Every shift", "Every week", "Setup", "When something goes wrong"];

export interface RoleListed {
  group: string;
  roles?: readonly string[];
}

/** The guides for a role (or all of them when no role is picked), grouped by rhythm in the shown order. A group with no
 * guide is left out. A group the list does not know comes after the known ones, in the order it first appears. */
export function groupGuidesByRhythm<T extends RoleListed>(
  guides: readonly T[],
  roleId: string | undefined,
): Array<[string, T[]]> {
  const picked = roleId === undefined ? guides : guides.filter((guide) => (guide.roles ?? []).includes(roleId));
  const groups = new Map<string, T[]>();
  for (const rhythm of HELP_RHYTHMS) groups.set(rhythm, []);
  for (const guide of picked) {
    const list = groups.get(guide.group) ?? [];
    list.push(guide);
    groups.set(guide.group, list);
  }
  return [...groups].filter(([, list]) => list.length > 0);
}

/** A remembered role id that is still one of the console's roles, else undefined. */
export function knownRoleId(roles: readonly HelpRole[], value: string | null | undefined): string | undefined {
  return roles.find((role) => role.id === value)?.id;
}
